import { PersonalizationMap } from '@/stores/main'

export function getTextPersonalized(text: string, personalizationMap: PersonalizationMap): string {
  return text.replace(/##(.*?)##/g, (match, key) => {
    // Check if the key is an array index in the format "arrayKey[index]"
    const arrayMatch = key.match(/(.*?)\[(\d+)\]/)
    if (arrayMatch) {
      // The key is in the format "arrayKey[index]"
      const arrayKey = arrayMatch[1]
      const index = parseInt(arrayMatch[2], 10)
      return Array.isArray(personalizationMap[arrayKey])
        ? personalizationMap[arrayKey][index] || ''
        : ''
    }
    return personalizationMap[key] || ''
  })
}

export function getCapitalizedSchoolNameParts(
  schoolNameParts: string[] | null | undefined
): string[] {
  if (schoolNameParts) {
    // Ensure that each string is fully capitalized
    schoolNameParts = schoolNameParts.map((part) => part.toUpperCase())
  }
  return schoolNameParts || []
}

export function getTeamYearText(teamYear: number | null | undefined): string {
  let teamYearText = ''
  if (teamYear) {
    // If the team year is provided, it will be in the form "2023 - 2024"
    teamYearText = teamYear - 1 + ' - ' + teamYear
  }
  return teamYearText
}
